import { render, staticRenderFns } from "./AffiliateStylistForm.vue?vue&type=template&id=3862fa88&scoped=true&"
import script from "./AffiliateStylistForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateStylistForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3862fa88",
  null
  
)

export default component.exports